import React from "react"
import {
  ArrowUpRight,
  TiktokLogo,
  FacebookLogo,
  InstagramLogo,
  YoutubeLogo,
  PinterestLogo,
  TwitterLogo,
  Envelope,
} from "@phosphor-icons/react"

// assets
import bbLogo from "@images/Home/blackbough-logo.svg"

const NewsLetter = () => {

  const handleSocialMediaLinks = (type) => {
    console.log("socmed:",type)
  }

  return (
    <React.Fragment>
      <section className="news-letter">
        {/* <h5 className="text-[0.875rem]">NEWSLETTER</h5>
        <p>
          Sign up for our newsletter and be first on sales and new releases!
        </p>
        <section className="flex flex-nowrap justify-between flex-1 gap-x-3 mb-8">
          <input
            className="p-4 w-full text-base font-normal border border-[#D1D1D1]"
            type="email"
            name="email"
            placeholder="Your email address"
            aria-label="Your email address"
            id="email"
          />

          <button
            className="btn-primary"
            aria-label="newsletter-submit"
            onClick={() => {}}
          >
            <ArrowUpRight size={24} />
          </button>
        </section>

        <p>Or follow us through our social media pages</p> */}
      
        <div className="mb-4">
          <img
            className="h-auto w-[150px] lg:w-[276px] ml-0 justify-self-center md:justify-self-start"
            src={bbLogo}
            alt={"Blackbough Swim"}
          />
        </div>

        <section className="text-[#3D3D3D] flex justify-center md:justify-start gap-x-4">
          <a 
            href={'https://www.instagram.com/blackboughswim/?hl=en'}
            target="_blank"
            aria-label="follow-instagram"
          >
            <InstagramLogo
              size={24}
              weight="light"
              onClick={() => handleSocialMediaLinks("instagram")}
            />
          </a>
          <a 
            href={'https://www.facebook.com/blackboughswim/'}
            target="_blank"
            aria-label="follow-facebook"
          >
            <FacebookLogo
              size={24}
              weight="light"
            />
          </a>
          <a 
            href={'https://www.tiktok.com/@blackboughswimofficial'}
            target="_blank"
            aria-label="follow-tiktok"
          >
            <TiktokLogo
              size={24}
              weight="light"
            />
          </a>
          {/* <a 
            href={'#'}
            target="_blank"
          >
            <YoutubeLogo
              size={24}
              weight="light"
              onClick={() => handleSocialMediaLinks("youtube")}
            />
          </a> */}
          <a 
            href={'https://pin.it/4pqkb4F'}
            target="_blank"
            aria-label="follow-pinterest"
          >
            <PinterestLogo
              size={24}
              weight="light"
              onClick={() => handleSocialMediaLinks("pinterest")}
            />
          </a>
          <a 
            href={'mailto:aloha@blackboughswim.com'}
            target="_blank"
            aria-label="email"
          >
            <Envelope
              size={24}
              weight="light"
            />
          </a>
          {/* <a 
            href={'#'}
            target="_blank"
          >
            <TwitterLogo
              size={24}
              weight="light"
              onClick={() => handleSocialMediaLinks("twitter")}
            />
          </a> */}
        </section>
      </section>
    </React.Fragment>
  );
}

export default NewsLetter